import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const baseFeatures = [
  {
    icon: '🎬',
    title: 'Shot Extraction',
    description: 'Automatically detect and extract individual scenes from your videos with AI-powered scene detection.',
    route: '/extraction'
  },
  {
    icon: '🔗',
    title: 'Video Merge',
    description: 'Combine multiple video clips into one seamless video. Perfect for compilations and multi-part content.',
    route: '/merge'
  },
//   {
//     icon: '⚡',
//     title: 'Direct Upload to Cloud',
//     description: 'Videos upload directly to Cloudflare R2, bypassing server bottlenecks for faster processing.'
//   },
//   {
//     icon: '📊',
//     title: 'Real-time Progress',
//     description: 'Track upload and processing progress in real-time with detailed status updates.'
//   },
//   {
//     icon: '🔒',
//     title: 'Privacy First',
//     description: 'Your videos are processed securely and automatically deleted after download. No permanent storage.'
//   },
];

const FeatureGrid = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const features = [
    ...baseFeatures,
    isAuthenticated
      ? {
          icon: '⭐',
          title: 'Upgrade to Premium',
          description: 'Premium tier is coming soon. Stay tuned!',
          highlight: true
        }
      : {
          icon: '🆓',
          title: 'Free to Use',
          description: 'Start with 3 videos without registration. Register for FREE to unlock 30 videos/day!',
          route: '/register',
          highlight: true
        }
  ];

  const handleFeatureClick = (route) => {
    if (route) {
      navigate(route);
    }
  };

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-slate-800/30">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Powerful video processing tools
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Designed for creators, editors, content professionals and non-professional users.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`bg-slate-700/50 rounded-xl p-6 hover:bg-slate-700/70 transition-colors duration-200 border ${
                feature.highlight 
                  ? 'border-green-500/70 hover:border-green-400 shadow-lg shadow-green-500/20' 
                  : 'border-slate-600/50 hover:border-blue-500/50'
              } ${
                feature.route ? 'cursor-pointer' : ''
              }`}
              onClick={() => handleFeatureClick(feature.route)}
            >
              <div className="text-4xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-white mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                {feature.description}
              </p>
              {feature.highlight && (
                <div className="mt-4">
                  <span className="inline-flex items-center text-green-400 text-sm font-semibold">
                    {feature.route ? 'Register Now →' : 'Coming Soon'}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureGrid;
